import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import SampleTable from 'Components/table/SampleTable';

const Feed = () => {

  return (
    <div className="container">
      <Helmet>
        <title>Feed</title>
      </Helmet>

      <SampleTable />


    </div>
  )
};

export default Feed;
